import "../../../styles/Containers.css";

function NinjaBanner(props) {
  const { onClick, title, img } = props;
  return (
    <div>
        <div onClick={onClick} className="spc-between padding5 shadow-normal b-white radius2 marginUpDown5 hoverAnim">
          <p className="heading-3 paddingTop5 grey-1 rightAlign">{title}</p>
          <div className="">{img}</div>
      
      </div>
    </div>
  );
}
export default NinjaBanner;
